import * as React from 'react';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import { Tournament } from '../../../../../../models/tournament';
import { TournamentReportOptionsForm } from '../TournamentReportOptionsForm';
interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
  tournament: Tournament;
}
export function HighLevelTournamentSchoolAdminsReportForm(props: Props) {
  return (
    <TournamentReportOptionsForm
      {...props}
      reportType={REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.HIGH_LEVEL_TOURNAMENT_SCHOOL_ADMINS}
      description="View participating schools, including schools represented through area teams, and their contact details."
      options={[
        {
          field: 'isShowAllAdmins',
          label: 'Show all school administrators',
          hint: 'Include every school user with the Admin role.',
          initialValue: true
        }
      ]}
    />
  );
}
